import api from '../api/axios';

export const LoadBoard = async (userId: string, userRole: string) => {
  console.log('LoadBoard called for user:', userId, 'with role:', userRole);
  
  // 관리자인 경우 전체 팀 데이터를 볼 수 있도록 파라미터 구성 가능 (현재는 본인 위주)
  const params = userRole === '관리자' ? {} : { userId };
  //const response = await api.get('/boards', { params: { userId } });
  const response = await api.get('/boards', { params });
  
  return response.data;
};

export const LoadAllBoardsByWeek = async (weekTitle: string) => {
  console.log('LoadAllBoardsByWeek called for:', weekTitle);
  const response = await api.get('/boards', {
    params: { title: weekTitle, teamId: 'all' }
  });
  return response.data;
};

export const SaveBoard = async (board: any, userId: string) => {
  console.log('SaveBoard called:', board, userId);
  
  const response = await api.post('/boards', board);
  return '저장되었습니다.';
};

export const EditBoard = async (board: any, boardId: string | undefined) => {
  console.log('EditBoard called:', board, boardId);
  // 현재 SaveBoard가 Upsert 로직을 가지고 있으므로 별도 EditBoard는 생략 가능하거나
  // 상세 수정이 필요할 때 구현
  const response = await api.post('/boards', board);
  return '수정되었습니다.';
};
